<style lang="scss" scoped>
.sbscription-edit * {
  color: #606266;
}
.product-image {
  float: left;
  display: inline-block;
  vertical-align: middle;
  width: 64px;
  height: 64px;
  margin-right: 10px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.product-list {
  list-style: none;
  margin: 0;
  padding: 10px 0 0 0;

  li {
    float: left;
    width: 50%;
    padding: 0 10px 10px 0;
    box-sizing: border-box;
  }
  .product-card {
    padding: 5px;
    height: 64px;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    cursor: pointer;
  }
  .selected {
    border-color: #ffdcdc;
    background-color: #ffeded;
  }
}
.selected-product-tag {
  margin-right: 10px;
}
.product-list:after {
  content: '';
  display: block;
  clear: both;
}
.product-name {
  margin: 0;
  font-weight: bold;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 32px;
}
.product-quantity {
  margin: 0;
  color: #ccc;
  line-height: 24px;
}
.date-tag,
.day-tag {
  margin: 0 10px 10px 0;
  cursor: pointer;
}
</style>

<template>
  <div class="subscription-edit">
    <div class="container">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>

    <div class="container">
      <el-form label-width="100px" label-position="left">
        <el-form-item label="适用商品">
          <el-col span="16">
            <el-tag closable class="selected-product-tag" v-for="(p, i) of selectedProducts" :key="p.id" @close="() => selectedProducts.splice(i, 1)">{{ p.name }}</el-tag>
            <el-button class="add-products-btn" size="small" icon="el-icon-plus" @click="() => (productListVisible = true)" />
            <el-dialog title="添加商品" :visible.sync="productListVisible" width="80%">
              <el-input v-model="productName" placeholder="输入商品名称进行搜索" style="width: 260px;" size="small" />
              <el-button size="small" @click="() => searchProduct()" style="margin-left: 10px;">搜索</el-button>
              <ul class="product-list">
                <li v-for="p of products" :key="p.id">
                  <div class="product-card" :class="tempList.find(it => p.id === it.id) ? 'selected' : ''" @click="() => toggleProduct(p)">
                    <div
                      class="product-image"
                      :style="{
                        backgroundImage: `url(${p.imagesList && p.imagesList.length ? p.imagesList[0] : ''})`
                      }"
                    />
                    <p class="product-name">{{ p.name }}</p>
                  </div>
                </li>
              </ul>
              <div style="text-align: center;">
                <el-button plain @click="() => searchProduct(true)" :disabled="noMoreProducts" size="small">加载更多</el-button>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="productListVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="addProduct">确 定</el-button>
              </span>
            </el-dialog>
          </el-col>
        </el-form-item>

        <el-form-item label="周期购名">
          <el-col span="12">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="补充简述">
          <el-col span="12">
            <el-input type="textarea" v-model="form.description"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="配送周期">
          <el-radio v-model="form.kind" :label="1">每日一期</el-radio>
          <el-radio v-model="form.kind" :label="2">每周一期</el-radio>
          <el-radio v-model="form.kind" :label="3">每月一期</el-radio>
        </el-form-item>

        <el-form-item v-if="form.kind === 2" label="支持周几配送">
          <el-col span="12">
            <el-tag class="day-tag" v-for="(d, i) of days" :key="i" :effect="form.weeklistList.indexOf(i + 1) === -1 ? 'plain' : 'light'" @click="() => toggleDay(i + 1)">周{{ d }}</el-tag>
          </el-col>
        </el-form-item>

        <el-form-item v-if="form.kind === 3" label="支持几号配送">
          <el-col span="12">
            <el-tag class="date-tag" v-for="d of 31" :key="d" :effect="form.datelistList.indexOf(d) === -1 ? 'plain' : 'light'" @click="() => toggleDate(d)">{{ d }}号</el-tag>
          </el-col>
        </el-form-item>

        <el-form-item label="配送提前期">
          买家需提前
          <el-input-number size="small" :min="1" v-model="form.beforedaycount" style="width: 120px;" />
          天, 并在
          <el-input-number size="small" :min="1" :max="24" v-model="form.beforeoftheclock" style="width: 120px;" />
          点前下单, 才能在最近的配送周期内送达
        </el-form-item>

        <el-form-item label="起送期数">
          订单最少满
          <el-input-number size="small" v-model="form.minissuecount" type="" style="width: 120px;"> </el-input-number>
          期起送
        </el-form-item>
      </el-form>
    </div>
    <div class="container">
      <div class="buttons">
        <el-button v-if="$route.query.id" @click="onUpdate" type="primary">更新</el-button>
        <el-button v-if="!$route.query.id" @click="onCreate" type="primary">创建</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../service/grpc.js';
import { rpc, rpc1 } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import uploadFile from '../../components/uploadFile/index.vue';

export default {
  components: {
    uploadFile: uploadFile
  },
  data() {
    return {
      token: getToken(),
      selectedProducts: [],
      tempList: [],
      productListVisible: false,
      productName: '',
      form: {
        id: this.$route.query.id || null,
        productidlistList: [],
        name: '',
        description: '',
        kind: 1,
        weeklistList: [],
        datelistList: [],
        minissuecount: 0,
        beforedaycount: 0,
        beforeoftheclock: 0,
        enabled: 2
      },
      fetchProductLoading: false,
      products: [],
      noMoreProducts: false,
      days: ['一', '二', '三', '四', '五', '六', '日']
    };
  },
  watch: {
    productListVisible(v) {
      if (v) {
        this.tempList = [...this.selectedProducts];
        this.$nextTick(() => {
          this.searchProduct();
        });
      }
    },
    selectedProducts(v) {
      this.form.productidlistList = v.map(it => it.id);
    }
  },
  created() {
    if (this.$route.query.id) {
      rpc(
        'StoreSubscriptionService.GetSubscription',
        M('IDWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          id: this.$route.query.id
        })
      ).then(res => {
        this.form = res;
        this.resolveProducts();
      });
    }
  },
  methods: {
    async resolveProducts() {
      const productidlist = this.form.productidlistList;
      const res = await rpc(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: getToken() }),
          idlistList: productidlist,
          count: productidlist.length
        })
      );
      this.selectedProducts = res.productlistList;
    },
    searchProduct(more) {
      let loading = this.$loading();
      rpc1(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: getToken() }),
          name: this.productName || null,
          isonline: 1,
          sortby: 1,
          sort: 1,
          count: 20,
          idlessthan: more && this.products.length ? this.products[this.products.length - 1].id : null
        })
      ).then(res => {
        loading.close();
        loading = null;
        if (res && res.productlistList) {
          this.products = more ? this.products.concat(res.productlistList) : res.productlistList;
          if (!res.productlistList.length) {
            this.noMoreProducts = true;
            this.$message({
              message: '没有更多了！',
              type: 'info'
            });
          } else this.noMoreProducts = false;
        }
      });
    },
    onCreate() {
      const row = JSON.parse(JSON.stringify(this.form));
      rpc(
        'StoreSubscriptionService.CreateSubscription',
        M('SubscriptionWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          subscription: M('Subscription', row)
        })
      ).then(res => {
        this.$router.back();
      });
    },
    onUpdate() {
      const row = JSON.parse(JSON.stringify(this.form));
      rpc(
        'StoreSubscriptionService.UpdateSubscription',
        M('SubscriptionWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          subscription: M('Subscription', row)
        })
      ).then(res => {
        this.form = res;
        this.$message({
          message: '更新成功',
          type: 'success'
        });
      });
    },
    toggleProduct(p) {
      const index = this.tempList.findIndex(it => it.id === p.id);
      if (index !== -1) {
        this.tempList.splice(index, 1);
      } else {
        this.tempList.push(p);
      }
    },
    addProduct() {
      this.selectedProducts = [...this.tempList];
      this.productListVisible = false;
    },
    toggleDay(d) {
      const index = this.form.weeklistList.indexOf(d);
      if (index !== -1) this.form.weeklistList.splice(index, 1);
      else this.form.weeklistList.push(d);
    },
    toggleDate(d) {
      const index = this.form.datelistList.indexOf(d);
      if (index !== -1) this.form.datelistList.splice(index, 1);
      else this.form.datelistList.push(d);
    }
  }
};
</script>
